import { store } from "app/store";
import { setId } from "entities/space/store";

export const getSpaceId = () => {
  const state = store.getState();
  const spaceId: number =
    state.space.id > 0
      ? state.space.id
      : parseInt(localStorage.getItem("spaceId") ?? "0");

  if (spaceId > 0 && !state.space.id) {
    store.dispatch(setId(spaceId));
  }
  return spaceId;
};

export const setSpaceId = (id: number) => {
  if (id > 0) {
    localStorage.setItem("spaceId", id.toString());
    store.dispatch(setId(id));
  }
  return id;
};
